export const DASHBOARD_USER_DATA_API = '/api/dashboard/user/user-data'
